import { render, staticRenderFns } from "./UntisTable.vue?vue&type=template&id=aa8dde0e&scoped=true"
import script from "./UntisTable.vue?vue&type=script&lang=js"
export * from "./UntisTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa8dde0e",
  null
  
)

export default component.exports